/**
 * Enumeration and properties pertaining to search.
 *
 * @class SearchTypes
 * @name types
 * @memberof Mojito.Applications.Sports.Search
 */
export default class SearchTypes {}

/**
 * Enumerator representing the available search appearances.
 *
 * `SEARCH` keeps the original inline search markup and behaviour. `DISCOVERY`
 * selects the overlay-based search experience configured through
 * `searchDiscoveryView`.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Applications.Sports.Search.types
 */
SearchTypes.APPEARANCE = {
    SEARCH: 'search',
    DISCOVERY: 'discovery',
};
